import React from "react";
import PropTypes from "prop-types";
import { formatDate, formatDateToMonthDay } from "./calendar_component";

// TODO is last year for some reason
const CalendarEventsDisplay = ({ displayForDates, weeksToRender }) => {
  return weeksToRender.map((days) => {
    return days.map((day) => {
      const formattedDay = formatDate(day);
      const Display = displayForDates[formattedDay];
      if (!Display) return <></>;
      const isCurrentDay = formattedDay == formatDate(new Date());
      return (
        <div key={day} className="all-dates-container">
          <div
            className={`box ${isCurrentDay ? "current-day" : ""}`}
            id={isCurrentDay ? "current-day" : ""}
          >
            <p className="log-margin">{formatDateToMonthDay(new Date(day))}</p>
            <div className="shift-box">{Display ? Display : <></>}</div>
          </div>
        </div>
      );
    });
  });

  // return (
  //   Object.keys(displayForDates).map(displayForDate => {
  //     const Display = displayForDates[displayForDate];
  //     const isCurrentDay = displayForDate == formatDate(new Date());
  //     return (
  //       <div key={displayForDate} className="all-dates-container">
  //         <div className={`box ${isCurrentDay ? "current-day" : ""}`} id={isCurrentDay ? "current-day" : ""}>
  //           <p className="log-margin">{formatDateToMonthDay(new Date(displayForDate))}</p>
  //           <div className="shift-box">
  //             {Display ? Display : <></>}
  //           </div>
  //         </div>
  //       </div>
  //     );
  //   })
  // );
};

CalendarEventsDisplay.propTypes = {
  displayForDates: PropTypes.object
};

export default CalendarEventsDisplay;
